import { z } from "zod";
export const snapshotDrillIdSchema = z.enum(["sleep", "recovery", "strain", "body"]);
/** Which behaviour each drill grades. Food and connection have no drill. */
export const SNAPSHOT_DRILL_PILLAR = {
    sleep: "sleep",
    recovery: "stress",
    strain: "movement",
    body: null,
};
export const SNAPSHOT_DRILL_FOR_BEHAVIOUR = new Map(Object.entries(SNAPSHOT_DRILL_PILLAR).flatMap(([id, pillar]) => pillar ? [[pillar, id]] : []));
//# sourceMappingURL=snapshot-drills.js.map